import React, { useState } from "react"
import Link from "components/Link"
import ContactSalesModal from "components/ContactSalesModal"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

const features = [
  {
    title: "Ask questions, get charts",
    description:
      "Preset Chatbot turns plain-English questions into visualizations and dashboards through conversation — no SQL, no drag-and-drop, just answers.",
  },
  {
    title: "Works with the AI tools you already use",
    description:
      "Preset's MCP service connects Claude, Cursor, and other MCP-compatible AI tools directly to your data, so you can query and visualize from wherever you already work.",
  },
  {
    title: "Trustworthy by design",
    description:
      "AI queries respect the same row-level security and permission model as your dashboards. Every generated query is visible and editable — no black boxes.",
  },
]

function AISection() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <section className="bg-catskill-white py-16 lg:py-24">
      <Container>
        <Heading
          label="AI-Powered Analytics"
          title="Conversational analytics, built on open source"
          subtitle={
            <>
              Preset Chatbot lets you ask questions and get charts through
              natural conversation. Preset&apos;s MCP service brings that same
              power to Claude, Cursor, and other AI tools you already use — all
              backed by Apache Superset&apos;s open architecture and
              enterprise-grade security.
            </>
          }
          decoration="border"
        />
        <div className="mt-12 grid grid-cols-1 gap-y-10 md:grid-cols-3 md:gap-x-10 lg:gap-x-12 xl:gap-x-20">
          {features.map((feature) => (
            <div key={feature.title} className="flex flex-col space-y-3">
              <h3 className="text-xl font-bold text-black">{feature.title}</h3>
              <p className="text-base text-dark-grey">{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 flex flex-col space-y-4 sm:flex-row sm:items-center sm:space-x-6 sm:space-y-0">
          <Button
            href="/contact-sales/"
            color="green"
            size="medium"
            onClick={(e) => {
              e.preventDefault()
              setIsModalOpen(true)
            }}
            trackClick="Talk to Sales (ai-section)_Product"
            shadow
          >
            Talk to Sales
          </Button>
          <Link className="text-base font-semibold text-lush" href="/ai/">
            Meet Preset Chatbot →
          </Link>
        </div>
      </Container>
      <ContactSalesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sourcePage="product-ai-section"
      />
    </section>
  )
}

export default AISection
